import { useState } from 'react';
import { Box, Typography, Card, CardContent, Stack, TextField, Alert } from '@mui/material';
import { navigate } from '../../lib/navigation';
import Button from '../../components/Button';
import LogoMark from '../../components/LogoMark';

function ClaimPage({ authActions }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await authActions.claim(code);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3 }}>
      <Card sx={{ maxWidth: 420, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ mb: 3 }}>
            <LogoMark />
          </Box>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Claim your profile
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Enter the claim code you were given to link this account to your existing CreatorCV profile.
          </Typography>
          <Box component="form" onSubmit={submit}>
            <Stack spacing={2}>
              {error && <Alert severity="error">{error}</Alert>}
              <TextField fullWidth label="Claim code" value={code} onChange={(event) => setCode(event.target.value)} required />
              <Button type="submit" disabled={submitting}>
                {submitting ? 'Claiming…' : 'Claim profile'}
              </Button>
              <Button variant="ghost" onClick={() => navigate('/onboarding')}>
                I don't have a code — create my own
              </Button>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default ClaimPage;
